import React from "react";
import {WithLoggedInAuthInfoProps, withRequiredAuthInfo} from "@propelauth/react";
import {DataTable} from "../ui/dataTable";
import {fetchWithToken} from "../../api/apiBase";
import {company_directory_columns, project_directory_columns} from "../directory/Directory";

import useSWR, {mutate, MutatorCallback} from "swr";
import InviteUserDialog from "./InviteUserToCompanyDialog";
import {ColumnDef} from "@tanstack/react-table";
import {PermissionedDirectoryEntry} from "@models/permissions";
import {UserContext} from "../../contexts/UserContext";
import {Button} from "../ui/button";
import {DotsHorizontalIcon, Pencil1Icon} from "@radix-ui/react-icons";
import {Link} from "react-router-dom";
import BaseLoadingSpinner from "../ui/baseLoadingSpinner";



/**
 * Simple component that displays a table of directory entries
 * I should wrap this with a state compoenent that also does adding and deleting etc.
 * The other thing here is that should be added for authorized users...
 * Type:
 *      <PermissionedDirectoryEntry[] >
 *
 *
 * */
function CompanyDirectoryView(props: WithLoggedInAuthInfoProps) {
    const userContext = React.useContext(UserContext)

    // const {data, error, isLoading} = useSWR<PermissionedDirectoryEntry[], any>(
    const {data, error, isLoading} = useSWR(
        [`/company/directory`, props.accessToken as string],
        ([url, token]) => fetchWithToken(url, token))


    const onSubmitInvite = (user: any) => {
        console.log(" user invited ", user)
        mutate([`/company/directory`, props.accessToken])
    }

    const extra: ColumnDef<PermissionedDirectoryEntry>[] = [
    {
        header: 'Actions',
        id: 'actions',
        cell: ({row}:any) => {
            const user_id = row.original.user.email
            if(userContext?.company_permissions?.edit_users) {
                return <div><Link to={`/company/manage/${user_id}`}>
                    <Button variant="outline">
                    <DotsHorizontalIcon className="h-4 w-4"/></Button></Link>

                </div>
            } else { <></>}
        }
    }, ...company_directory_columns
    ]


    if (isLoading) return <div><BaseLoadingSpinner/></div>
    if (error) return <div>Error loading project</div>

    return (
        <div>
            {userContext?.company_permissions?.invite_users
                && <InviteUserDialog onSubmit={onSubmitInvite}/>

            }
            <DataTable data={data} columns={extra}/>
        </div>
    );
}

export default withRequiredAuthInfo(CompanyDirectoryView);
